"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
/**
 * HOC for input with value and debounced onChange.
 *
 * @param {String} valueProp Name of value property (default 'value')
 * @param {String} onChangeProp Name of onChange property (default 'onChange')
 * @param {Number} wait Number of miniseconds to debounce
 * @param {Object} options Lodash debounce options
 */
exports.default = (function (valueProp, onChangeProp, wait, options) {
    if (valueProp === void 0) { valueProp = 'value'; }
    if (onChangeProp === void 0) { onChangeProp = 'onChange'; }
    if (wait === void 0) { wait = '500'; }
    if (options === void 0) { options = {}; }
    return function (component) {
        var _a;
        return recompose_1.compose(recompose_1.mapProps(function (_a) {
            var _b = valueProp, value = _a[_b], _c = onChangeProp, onChange = _a[_c], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + "", typeof _c === "symbol" ? _c : _c + ""]);
            return (__assign({ valueDebounced: value, onChangeDebounced: lodash_1.debounce(onChange, wait, options) }, rest));
        }), recompose_1.withState(valueProp, 'setValue', function (_a) {
            var valueDebounced = _a.valueDebounced;
            return valueDebounced;
        }), recompose_1.lifecycle({
            componentWillReceiveProps: function (newProps) {
                if (this.props.valueDebounced !== newProps.valueDebounced) {
                    this.props.setValue(newProps.valueDebounced);
                }
            },
        }), recompose_1.withHandlers((_a = {},
            _a[onChangeProp] = function (_a) {
                var onChangeDebounced = _a.onChangeDebounced, setValue = _a.setValue;
                return function (value) {
                    setValue(value);
                    onChangeDebounced(value);
                };
            },
            _a)), recompose_1.mapProps(function (_a) {
            var valueDebounced = _a.valueDebounced, onChangeDebounced = _a.onChangeDebounced, setValue = _a.setValue, rest = __rest(_a, ["valueDebounced", "onChangeDebounced", "setValue"]);
            return (__assign({}, rest));
        }))(component);
    };
});
//# sourceMappingURL=debounced.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/debounced.js
// module id = 550
// module chunks = 0